import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Table, Pagination, TableActions, TableAction, TableData, TableDataTypes } from '../shared/types';
import { LoaderService } from '../loader.service';
import { AuthService } from '../auth.service';
import { IncentiveApprovalRequestsService } from './incentive-approval-requests.service';
import { ToasterService } from '../toaster.service';
import { Toaster, ToasterType } from '../shared/types/toaster.types';
import { SharedService } from '../shared/shared.service';
import { AUTHZ_FEATURES } from '../constants/permissions';
import { permissionSlugs } from '../utils/permission.utils';
import { AuthzAccessHintService } from '../shared/authz-access-hint/authz-access-hint.service';
var IncentiveApprovalRequestsComponent = /** @class */ (function () {
    function IncentiveApprovalRequestsComponent(approvalRequestsService, loaderService, router, accessRights, toastService, sharedService, authzAccessHintService) {
        this.approvalRequestsService = approvalRequestsService;
        this.loaderService = loaderService;
        this.router = router;
        this.accessRights = accessRights;
        this.toastService = toastService;
        this.sharedService = sharedService;
        this.authzAccessHintService = authzAccessHintService;
        this.authzAccessHint = null;
        this.showFilters = true;
        this.listFilters = {
            requestStatus: 'PENDING'
        };
        this.sortableColumns = [
            'active',
            'operation',
            'cities',
            'incentiveName',
            'serviceNames',
            'startDate',
            'endDate',
            'type',
            'priority',
        ];
        this.sort = {};
        this.table = new Table({
            headers: {
                active: 'Status',
                operation: 'Operation',
                cities: 'City',
                incentiveName: 'Name',
                serviceNames: 'Service',
                startDate: 'Start Date',
                endDate: 'End Date',
                type: 'Type',
                priority: 'Priority',
                action: 'Actions'
            },
            sortableColumnKeys: [
                'active',
                'operation',
                'cities',
                'incentiveName',
                'serviceNames',
                'startDate',
                'endDate',
                'type',
                'priority',
            ],
            pagination: new Pagination(0, 15, 150, [15, 20]),
            data: []
        });
        this.cities = [];
        this.services = {};
        this.citiesFilter = {
            type: 'searchable-dropdown',
            title: 'City',
            values: [],
            default: [],
            key: 'approval-city'
        };
        this.serviceFilter = {
            type: 'searchable-dropdown',
            title: 'Services',
            values: [],
            default: [],
            key: 'approval-services'
        };
        this.filterComponents = [
            this.citiesFilter,
            this.serviceFilter,
            {
                type: 'searchable-dropdown',
                title: 'Incentive Type',
                values: this.sharedService.INCENTIVE_TYPES,
                default: [],
                key: 'approval-types'
            },
            {
                type: 'searchable-dropdown',
                title: 'Operation',
                values: ['Create', 'Update'],
                default: [],
                key: 'approval-operations'
            },
            {
                type: 'calendar',
                title: '',
                values: [],
                default: undefined,
                key: 'approval-dates'
            },
            {
                type: 'radio-button',
                title: 'Status',
                values: ['All', 'Pending', 'Approved', 'Rejected'],
                default: 'Pending',
                key: 'approval-request-status'
            }
        ];
    }
    IncentiveApprovalRequestsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchAllCities()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchTableData()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.loadAccessHint()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IncentiveApprovalRequestsComponent.prototype.loadAccessHint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.authzAccessHintService.getAccessHintData('incentive')];
                    case 1:
                        _a.authzAccessHint = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IncentiveApprovalRequestsComponent.prototype.fetchAllCities = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var citiesRes;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.withLoader(function () { return _this.sharedService.fetchCities().toPromise(); })];
                    case 1:
                        citiesRes = _a.sent();
                        this.cities = citiesRes.data.cities;
                        this.citiesFilter.values = this.cities.map(function (city) { return city.displayName; });
                        return [2 /*return*/];
                }
            });
        });
    };
    IncentiveApprovalRequestsComponent.prototype.fetchServices = function (cityDisplayNames) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _loop_1, this_1, _i, cityDisplayNames_1, cityName;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.services = {};
                        _loop_1 = function (cityName) {
                            var city, res, _i, _a, serviceDetail, name_1;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        city = this_1.cities.find(function (c) { return c.displayName === cityName; });
                                        if (!city) {
                                            return [2 /*return*/, "continue"];
                                        }
                                        return [4 /*yield*/, this_1.sharedService.fetchServices(city._id).toPromise()];
                                    case 1:
                                        res = _b.sent();
                                        for (_i = 0, _a = res.data; _i < _a.length; _i++) {
                                            serviceDetail = _a[_i];
                                            name_1 = serviceDetail.service.name;
                                            this_1.services[name_1] = this_1.services[name_1] || [];
                                            this_1.services[name_1].push(serviceDetail._id);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _i = 0, cityDisplayNames_1 = cityDisplayNames;
                        _a.label = 1;
                    case 1:
                        if (!(_i < cityDisplayNames_1.length)) return [3 /*break*/, 4];
                        cityName = cityDisplayNames_1[_i];
                        return [5 /*yield**/, _loop_1(cityName)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.serviceFilter.values = Object.keys(this.services);
                        return [2 /*return*/];
                }
            });
        });
    };
    IncentiveApprovalRequestsComponent.prototype.fetchTableData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.withLoader(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var response;
                            var _this = this;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.approvalRequestsService.fetchApprovalRequests({
                                            pageNumber: this.table.pagination.pageNo,
                                            pageLimit: this.table.pagination.perPage,
                                            requestStatus: this.listFilters.requestStatus,
                                            cities: this.listFilters.cities,
                                            serviceTypes: this.listFilters.serviceTypes,
                                            types: this.listFilters.types,
                                            operations: this.listFilters.operations,
                                            fromDate: this.listFilters.fromDate,
                                            toDate: this.listFilters.toDate,
                                            sortBy: this.sort.sortBy,
                                            sortOrder: this.sort.sortOrder,
                                        }).toPromise()];
                                    case 1:
                                        response = _a.sent();
                                        this.table.pagination.count = response.documentCount || 0;
                                        this.table.data = (response.data || []).map(function (row) {
                                            var incentive = row.newValue || {};
                                            var cities = incentive.cities || [];
                                            var serviceNames = incentive.serviceNames || [];
                                            return {
                                                _id: row._id,
                                                requestStatus: row.requestStatus,
                                                createdBy: row.createdBy,
                                                resourceId: row.resourceId,
                                                resource: row.resource,
                                                key: row.key,
                                                version: row.version,
                                                newValue: incentive,
                                                oldValue: row.oldValue || null,
                                                active: _this.formatRequestStatus(row.requestStatus),
                                                operation: _this.formatRequestStatus(row.operation),
                                                cities: _this.formatCityNames(cities),
                                                incentiveName: incentive.incentiveName || '',
                                                serviceNames: serviceNames.join(', '),
                                                startDate: incentive.startDate,
                                                endDate: incentive.endDate,
                                                type: incentive.incentiveType,
                                                priority: incentive.priority || 0,
                                                action: _this.createViewAction(row),
                                            };
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IncentiveApprovalRequestsComponent.prototype.formatCityNames = function (cityIds) {
        var _this = this;
        return (cityIds || [])
            .map(function (id) {
            var city = _this.cities.find(function (c) { return String(c._id) === String(id); });
            return city ? city.displayName : id;
        })
            .join(', ');
    };
    IncentiveApprovalRequestsComponent.prototype.formatRequestStatus = function (status) {
        if (!status) {
            return '';
        }
        return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    };
    IncentiveApprovalRequestsComponent.prototype.createViewAction = function (row) {
        var _this = this;
        var actionArr = [];
        if (this.accessRights.isAuthorizedFor(permissionSlugs(AUTHZ_FEATURES.INCENTIVE, ['view', 'edit', 'approve'], this.accessRights.getAuthzPanels()), AUTHZ_FEATURES.INCENTIVE)) {
            actionArr.push(new TableAction({
                onClick: function () { return _this.openPreview(row); },
                text: 'View'
            }));
        }
        return new TableData({
            actions: new TableActions(actionArr),
            type: TableDataTypes.ACTION
        });
    };
    IncentiveApprovalRequestsComponent.prototype.openPreview = function (row) {
        var requestId = row && row._id;
        if (!requestId) {
            this.toastService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: 'Approval request id is missing.'
            }));
            return;
        }
        this.approvalRequestsService.storePreviewForRequest(requestId, {
            requestId: requestId,
            requestStatus: row.requestStatus,
            operation: row.operation,
            createdBy: row.createdBy,
            resourceId: row.resourceId,
            resource: row.resource,
            key: row.key,
            version: row.version,
            newValue: row.newValue || {},
            oldValue: row.oldValue || null,
        });
        this.router.navigate(['/incentive-approval-requests', requestId], { queryParams: { preview: 'approval' } });
    };
    IncentiveApprovalRequestsComponent.prototype.sortByHeader = function (header) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sortOrder, column;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sortOrder = header.includes('-') ? -1 : 1;
                        column = header.replace('-', '');
                        if (this.sortableColumns.indexOf(column) < 0) {
                            return [2 /*return*/];
                        }
                        this.sort = { sortBy: column, sortOrder: sortOrder };
                        this.table.pagination.setPageNoToZero();
                        return [4 /*yield*/, this.fetchTableData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IncentiveApprovalRequestsComponent.prototype.filterChange = function (filters) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(filters['approval-city'] && filters['approval-city'].length)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.withLoader(function () { return _this.fetchServices(filters['approval-city']); })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    IncentiveApprovalRequestsComponent.prototype.applyFilters = function (filters) {
        this.table.pagination.setPageNoToZero();
        var statusLabel = filters['approval-request-status'] || 'All';
        var requestStatusMap = {
            All: undefined,
            Pending: 'PENDING',
            Approved: 'APPROVED',
            Rejected: 'REJECTED',
        };
        var approvalDates = filters['approval-dates'] || [];
        var fromDate = approvalDates[0];
        var toDate = approvalDates[1];
        var serviceTypeIds = [];
        for (var _i = 0, _a = (filters['approval-services'] || []); _i < _a.length; _i++) {
            var serviceName = _a[_i];
            serviceTypeIds = serviceTypeIds.concat(this.services[serviceName] || []);
        }
        var cityNames = (filters['approval-city'] || []).map(String).filter(Boolean);
        this.listFilters = {
            requestStatus: requestStatusMap[statusLabel],
            cities: cityNames.length ? cityNames : undefined,
            serviceTypes: serviceTypeIds.length ? serviceTypeIds : undefined,
            types: (filters['approval-types'] || []).length ? filters['approval-types'] : undefined,
            operations: (filters['approval-operations'] || []).length
                ? filters['approval-operations'].map(function (op) { return op.toLowerCase(); })
                : undefined,
            fromDate: fromDate || undefined,
            toDate: toDate || undefined,
        };
        this.fetchTableData();
    };
    IncentiveApprovalRequestsComponent.prototype.withLoader = function (cb) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 2, 3]);
                        this.loaderService.openLoading();
                        return [4 /*yield*/, cb()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        this.loaderService.closeLoading();
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return IncentiveApprovalRequestsComponent;
}());
export { IncentiveApprovalRequestsComponent };
